(function () {
  angular.module("akitabox.serviceRequest.create", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.asset",
    "akitabox.core.services.floor",
    "akitabox.core.services.issueType",
    "akitabox.core.services.pinValue",
    "akitabox.core.services.request",
    "akitabox.core.services.room",
    "akitabox.core.toast",
  ]);
})();
